export function isPaymentLinkTag(tagKey: string): boolean {
  const normalized = tagKey.replace(/^\{\{|\}\}$/g, '').trim().toLowerCase();
  return normalized === 'payment_link';
}
